<template>
	<section>
		<el-drawer :title="titleObj[type]" v-bind="$attrs" :visible.sync="is_show" v-on="$listeners" @opened="onOpen"
			@close="onClose">
			<div class="form-body">
				<parser v-if="formObj" :form-conf="formObj" @submit="sumbitForm" @save="saveForm"
					:is_show_save="(status=='UNPASSED'||status=='REVOKE')&&type=='update'" ref="parserRef" />

				<el-form v-if="formData&&type!='preview'" style="padding-left:30px;margin-top:60px">
					<el-divider></el-divider>
					<el-form-item label="申请人" v-if="formData.applicant" style="margin-bottom:10">
						{{formData.applicant.name}}</el-form-item>
					<el-form-item label="审核人" style="margin-bottom:0">
						<el-button @click="setUser(1)" type plain icon="el-icon-plus" size="small"
							style="margin-right:10px;">添加</el-button>
						<span v-if="formData.checkers&&formData.checkers.length">
							<el-tag v-for="(user,index) in formData.checkers" :key="index" type="info" closable
								@close="delChecker(index)">{{user.name}}</el-tag>
						</span>
					</el-form-item>
					<el-form-item label="抄送人">
						<el-button @click="setUser(2)" type plain icon="el-icon-plus" size="small"
							style="margin-right:10px;">添加</el-button>
						<span v-if="formData.notifiers&&formData.notifiers.length">
							<el-tag v-for="(user,index) in formData.notifiers" :key="index" type="info" closable
								@close="delNotifyer(index)">{{user.name}}</el-tag>
						</span>
					</el-form-item>
				</el-form>
			</div>
		</el-drawer>

		<select-business :visible="is_select" :business_type="business_type" :maxNumber="maxNumber"
			:defaultCheckIds="defaultIds" @closeSelect="is_select=false" @submit="submitBusiness"></select-business>
	</section>
</template>
<script>
	import Parser from "@/components/form/parser/Parser"; //解析器

	import { oa_approvals } from "@/api/oa";
	// type:fill填写，update修改，preview预览
	//status申请单状态

	import selectBusiness from "@/components/form/index/selectBusiness";
	import { businessName } from "@/components/form/generator/config";
	export default {
		components: { Parser, selectBusiness },
		props: ["formData", "type", "status", "visible"],
		data() {
			return {
				is_show: false,
				titleObj: {
					fill: "填写表单",
					update: "修改表单",
					preview: "表单预览",
					disable: "查看表单",
				},
				formObj: null,
				is_select: false,
				business_type: "student",
				select_index: 0, //当前选中的业务控件
				maxNumber: 0,
				defaultIds: [],
				set_type: 0, //1设置审核人，2设置抄送人，0选择业务
			};
		},
		computed: {},
		watch: {
			visible(newV, oldV) {
				if (newV) {
					this.is_show = true;
				} else {
					this.is_show = false;
				}
			},
		},
		created() { },
		mounted() { },
		beforeDestroy() { },
		methods: {
			setUser(val) {
				this.set_type = val; //val==1设置抄送人

				this.business_type = "teacher";
				this.maxNumber = 0;

				let user_ids = [];
				if (val == 1) {
					user_ids =
						this.formData.checkers && this.formData.checkers.length
							? this.formData.checkers.map((r) => r.user_id)
							: [];
				} else {
					user_ids =
						this.formData.notifiers && this.formData.notifiers.length
							? this.formData.notifiers.map((r) => r.user_id)
							: [];
				}
				this.defaultIds = user_ids;
				this.is_select = true;
			},
			delChecker(index) {
				this.formData.checkers.splice(index, 1);
			},
			delNotifyer(index) {
				this.formData.notifiers.splice(index, 1);
			},
			toCommit(data, val) {
				let param = {
					form_id: this.formData._id || this.formData.id,
					type: 1,
					content: data,
					checker_ids:
						this.formData.checkers && this.formData.checkers.length > 0
							? this.formData.checkers.map((r) => r.user_id)
							: [],
					notifier_ids:
						this.formData.notifiers &&
							this.formData.notifiers.length > 0
							? this.formData.notifiers.map((r) => r.user_id)
							: [],
				};

				if (!param.checker_ids.length) {
					this.$notify({
						title: "提示",
						type: "error",
						duration: 2000,
						message: "请选择审核人！",
					});
					return;
				}
				if (this.type == "update" && this.formData.apply_id) {
					param = Object.assign(param, {
						id: this.formData.apply_id,
						recommit:
							val == 1 &&
								this.type == "update" &&
								(this.status == "UNPASSED" || this.status == "REVOKE")
								? true
								: false,
					}); //保存后直接提交
				}

				let promise =
					this.type == "update" && this.formData.apply_id
						? oa_approvals.update(param)
						: oa_approvals.apply(param);

				promise.then((res) => {
					if (res.data) {
						this.$notify({
							title: "提示",
							type: "success",
							duration: 2000,
							message: "提交成功！",
						});
						this.$emit("submit");
					}
				});
			},
			saveForm(data) {
				this.toCommit(data, 0);
			},
			sumbitForm(data) {
				this.toCommit(data, 1);
			},

			onOpen() {
				if (!this.formData || !this.formData.config) {
					return;
				}
				let that = this;
				this.formObj = Object.assign(this.formData.config, {
					__methods__: {
						openSelect(e) {
							that.set_type = 0;
							that.business_type = e.business_type || "student";
							that.maxNumber = e.max || 0;
							that.select_index =
								that.formData.config.fields.findIndex(
									(r) => r.__vModel__ == e.__vModel__
								) || 0;
							that.defaultIds =
								e.__config__.defaultValue &&
									e.__config__.defaultValue.length
									? e.__config__.defaultValue
										.map((x) => {
											return x && x.value
												? x.value
												: x || null;
										})
										.filter((e) => e)
									: [];
							that.is_select = true;
						},
					},
				});
			},
			submitBusiness(data) {
				console.log("this.parserRef", this.$refs.parserRef);
				this.is_select = false;
				if (this.set_type > 0) {
					//选择审核人或抄送人
					if (this.set_type == 1) {
						this.formData.checkers = data.map((r) => {
							return {
								user_id: r.value,
								name: r.label,
							};
						});
					} else {
						this.formData.notifiers = data.map((r) => {
							return {
								user_id: r.value,
								name: r.label,
							};
						});
					}
					return;
				}

				// 选择业务处理
				//以下操作的目的是刷新页面，否则动态选择组件不会自动更新
				let { fields, ...others } = this.formObj;
				fields = this.$refs.parserRef.formConfCopy
					? this.$refs.parserRef.formConfCopy.fields
					: fields; //从parserRef中获取填写的表单拷贝

				let item = fields[this.select_index];

				this.formObj = null; //强制更新parserRef

				this.$nextTick(() => {
					item.__config__.defaultValue =
						data && data.length
							? data.map((r) => {
								return { label: r.label, value: r.value };
							})
							: [];
					let str = `${data && data.length ? "已选择" + data.length : ""
						}`;

					//设置按钮名称
					item.__slot__.default = str
						? str
						: businessName[this.business_type];
					fields.splice(this.select_index, 1, item);

					this.formObj = Object.assign(others, { fields: fields });
				});
			},
			onClose() {
				this.formObj = null;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.form-body {
		height: calc(100vh - 80px);
		overflow: auto;
		padding-bottom: 30px;
		padding: 0 30 30 0;
	}
	.el-tag {
		margin-right: 10px;
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/form_custom/preview/index.vue